/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore', 'assets/js/modules/utils'], function(backbone, _, utils) {
    return backbone.Model.extend({
        defaults: {
            pricingCalcItems: new backbone.Collection(),

            pricingSetName: null,
            discountCode: 0,
            price: null,

            //when undefined, do not throw zip validation errors on Start Page
            zip: undefined,

            // When null, use net prices
            vatRate: null,

            //todo restructure availableShipping
            availableShipping: null,
            shipping: {
                method: null,
                code: null,
                category: null,
                date: null,
                price: null,
                methodValue: null,
                location: null
            },

            eventAgent: {}
        },

        setShipping: function(attributes) {
            var shipping = this.get('shipping') || {};
            _.extend(shipping, attributes);
            this.set({ shipping: shipping });
        },

        dropShipping: function() {
            this.set({ shipping: null });
        },
        applyVatToPrice: function(price) {
            return utils.applyVat(price, this.get('vatRate'));
        },
        getClosestAvailableShipping: function() {
            if (!this.get('availableShipping')) {
                return null;
            }
            if (this.get('shipping') === null) {
                return null;
            }
            var shippingServiceCode = this.get('shipping').code ? this.get('shipping').code : null;
            var code = shippingServiceCode ? shippingServiceCode.toString() : null;
            var category = this.get('shipping').category;
            var location = this.get('shipping').location;
            var selectedShipping;

            var filteredShipping = _.filter(this.get('availableShipping'), { shipping_carrier_service_code: code, category: category });
            if (filteredShipping !== undefined) {
                selectedShipping = _.find(filteredShipping, function(shippingObj) {
                    return _.findWhere(shippingObj.pickup_locations, { id: location }) !== undefined;
                });
            }

            if (!selectedShipping && filteredShipping !== undefined) {
                selectedShipping = filteredShipping[0];
            }

            if (!selectedShipping) {
                selectedShipping = _.findWhere(this.get('availableShipping'), { shipping_carrier_service_code: code });
            }

            return selectedShipping;
        }
    });
});
